/**
 * Lima de noche (sections/chz-hero-bento.liquid, snippets/chz-lima-noche-fx.liquid).
 * La capa de autos, aviones, reflectores y ventanas usa animaciones SMIL, que no obedecen al CSS: este
 * script las pausa con movimiento reducido, con las animaciones apagadas (html[data-chz-motion='off']),
 * fuera de pantalla o con la pestaña oculta. El zeppelin y la luna son CSS y ya se detienen solos.
 */
const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

/** @param {SVGSVGElement} svg */
function setup(svg) {
  if (svg.dataset.chzReady) return;
  svg.dataset.chzReady = 'true';
  let visible = true;

  const update = () => {
    const off = reduced.matches || document.documentElement.dataset.chzMotion === 'off' || !visible || document.hidden;
    try {
      if (off) svg.pauseAnimations();
      else svg.unpauseAnimations();
    } catch {
      /* navegador sin SMIL */
    }
  };

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      visible = Boolean(entry?.isIntersecting);
      update();
    }).observe(svg);
  }
  reduced.addEventListener?.('change', update);
  new MutationObserver(update).observe(document.documentElement, { attributes: true, attributeFilter: ['data-chz-motion'] });
  document.addEventListener('visibilitychange', update);
  update();
}

function setupAll(scope = document) {
  for (const svg of scope.querySelectorAll('svg.chz-lima__fx')) {
    if (svg instanceof SVGSVGElement) setup(svg);
  }
}

setupAll();
document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) setupAll(event.target);
});
